import React from 'react';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn,  FaWhatsapp } from 'react-icons/fa';

const SocialWidget = () => {
//   const [isOpen, setIsOpen] = useState(false);

  const socialLinks = [
    { id: 1, icon: <FaFacebookF />, url: 'https://www.facebook.com/beninelectric', color: 'bg-blue-600' },
    { id: 2, icon: <FaTwitter />, url: 'https://x.com/beninelectric', color: 'bg-sky-400' },
    { id: 5, icon: <FaWhatsapp />, url: 'https://wa.me/2348125277248?text=Good%20Day%20BEDC', color: 'bg-green-700' },
    { id: 3, icon: <FaInstagram />, url: 'https://www.instagram.com/beninelectric/', color: 'bg-pink-600' },
    { id: 4, icon: <FaLinkedinIn />, url: 'https://www.linkedin.com/company/benin-electricity-distribution-plc/?viewAsMember=true', color: 'bg-blue-700' },
  ];

  return (
    <div className="fixed bottom-6 left-6 z-50 flex flex-col-reverse items-center gap-3">
      {/* Main Toggle Button */}
      {/* <button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-14 h-14 rounded-full shadow-2xl flex items-center justify-center text-white transition-transform duration-300 ${
          isOpen ? 'bg-gray-800 rotate-45' : 'bg-red-600'
        } hover:scale-110`}
      >
        <FaPlus size={24} />
      </button> */}

      {/* Floating Social Icons */}
      {/* <div className={`flex flex-col gap-3 transition-all duration-300 ${
        isOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'
      }`}>
        {socialLinks.map((link) => (
          <a
            key={link.id}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`${link.color} w-11 h-11 rounded-full flex items-center justify-center text-white shadow-lg hover:scale-110 transition-transform`}
          >
            {link.icon}
          </a>
        ))}
      </div> */}
      <div>
        {socialLinks.map((link) => (
          <a
            key={link.id}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`${link.color} w-11 h-11 rounded-full mt-5 flex items-center justify-center text-white shadow-lg hover:scale-110 transition-transform`}
          >
            {link.icon}
          </a>
        ))}
      </div>
    </div>
  );
};

export default SocialWidget;